<template>
  <div class="transcontainer" >
    <v-refresh :on-refresh="onRefreshone" >
      <v-reload
        :on-infinite-load="infinite"
        :parent-pull-up-state="infiniteLoadData.pullUpState"
      >
       <div v-if="list.length>0">
         <div class="itemlist" v-for="(item,index) in list" :key="index">
           <div class="header">
             <span v-if="item.status==0">待付款</span>
             <span v-if="item.status==1">已取消</span>
             <span v-if="item.status==2">已付款</span>
             <span v-if="item.status==3">已退款</span>
             <span class="price">{{item.price}} {{item.mType}}</span>
           </div>
           <div class="header">
             <span class="time">{{item.updateTime| dateformat('YYYY-MM-DD HH:mm')}}</span>
             <span class="time"  v-if="item.payType==1">微信支付</span>
             <span class="time"  v-if="item.payType==2">支付寶支付</span>
             <span class="time"  v-if="item.payType==3">綠界支付</span>
             <span v-if="item.payType==4">paypal</span>
               <span v-if="item.payType==5">淘宝店铺支付</span>
           </div>
         </div>
       </div>
        <noth-modal v-else></noth-modal>
        <div style="width: 100%;height: 2rem"></div>
      </v-reload>
    </v-refresh>
  </div>
</template>

<script>
import DropDownRefresh from '../../components/refresh'
import PullUpReload from '../../components/pullDown'
import NothModal from '../Modal/NothModal'
import { Toast } from 'mand-mobile'

export default {
  name: 'transaction',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'v-refresh': DropDownRefresh,
    // eslint-disable-next-line vue/no-unused-components
    'v-reload': PullUpReload,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  data () {
    return {
      infiniteLoadData: {
        initialShowNum: 10, // 初始显示多少条
        everyLoadingNum: 10, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
      },

      pagenum: 1,
      list: []
    }
  },
  activated () {
    this.getlist(null)
  },
  methods: {
    onRefreshone (done) {
      setTimeout(() => {
        this.infiniteLoadData.pullUpList = []
        this.pagenum = 1
        this.getlist(null)
        done()
      }, 500)
    },
    infinite (done) {
      console.log(this.infiniteLoadData.pullUpState)
      if (this.infiniteLoadData.pullUpState === 1) {
        setTimeout(() => {
          this.pagenum++
          this.getlist('load')
          done()
        }, 500)
      } else {
        this.infiniteLoadData.pullUpState = 0
      }
      done()
    },
    getlist (opear) {
      const par = {
        pageNum: this.pagenum,
        pageSize: 10,
        sort: false
      }
      this.http.APIASK(this.ports.orderpayList, 'get', par).then(res => {
        if (opear) {
          if (res.list.length > 0) {
            this.list = this.list.concat(res.list)
            this.infiniteLoadData.pullUpList = this.list
            if (res.list.length < 10) {
              this.infiniteLoadData.pullUpState = 3
            } else {
              this.infiniteLoadData.pullUpState = 1
            }
          } else {
            this.infiniteLoadData.pullUpState = 3
          }
        } else {
          if (res.list.length < 10) {
            this.infiniteLoadData.pullUpState = 3
          } else {
            this.infiniteLoadData.pullUpState = 1
          }
          this.list = res.list
          this.infiniteLoadData.pullUpList = this.list
        }
        this.list.length < 3 ? this.infiniteLoadData.pullUpState = 0 : null
        Toast.hide()
        console.log(this.favorites)
      }).catch(err => {
        Toast.hide()
      })
    }
  }
}
</script>

<style lang="less">
  .transcontainer{
    width: 100%;
   background-color: white;
    .itemlist{
      width:100%;
      height: 1.2rem;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-bottom: 0.2rem;
      border-bottom: 1px solid #cccccc;
      .header{
        width: 90%;
        margin-left: 5%;
        display: flex;
        justify-content: space-between;
        font-size: 0.32rem;
        .price{
          color: #32c5ea;
        }
      }
    }
  }

</style>
